// Generated by purs version 0.13.8
"use strict";
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Component_Editor_NodeUi = require("../Lunarbox.Component.Editor.NodeUi/index.js");
var GetValue = (function () {
    function GetValue(value0) {
        this.value0 = value0;
    };
    GetValue.create = function (value0) {
        return new GetValue(value0);
    };
    return GetValue;
})();
var NewValue = function (x) {
    return x;
};
var SetValue = (function () {
    function SetValue(value0) {
        this.value0 = value0;
    };
    SetValue.create = function (value0) {
        return new SetValue(value0);
    };
    return SetValue;
})();
var component = (function () {
    var render = function (v) {
        return Lunarbox_Component_Editor_NodeUi.runNodeUi({
            value: v.value,
            setValue: function ($19) {
                return Data_Maybe.Just.create(SetValue.create($19));
            }
        })(v.name);
    };
    var handleQuery = function (v) {
        return Data_Functor.mapFlipped(Halogen_Query_HalogenM.functorHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
            return Data_Functor.map(Data_Maybe.functorMaybe)(v.value0)(Lunarbox_Component_Editor_NodeUi.uiToRuntime(v1.name)(v1.value));
        });
    };
    var handleAction = function (v) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
            var $15 = {};
            for (var $16 in v1) {
                if ({}.hasOwnProperty.call(v1, $16)) {
                    $15[$16] = v1[$16];
                };
            };
            $15.value = v.value0;
            return $15;
        }))(function () {
            return Halogen_Query_HalogenM.raise(v.value0);
        });
    };
    return Halogen_Component.mkComponent({
        initialState: Control_Category.identity(Control_Category.categoryFn),
        render: render,
        "eval": Halogen_Component.mkEval({
            handleAction: handleAction,
            handleQuery: handleQuery,
            receive: Halogen_Component.defaultEval.receive,
            initialize: Halogen_Component.defaultEval.initialize,
            finalize: Halogen_Component.defaultEval.finalize
        })
    });
})();
module.exports = {
    GetValue: GetValue,
    NewValue: NewValue,
    component: component
};
